import React from 'react';
import HealthBubble from './HealthBubble';

interface BubbleTextProps {
  tooltip?: string;
  style?: React.CSSProperties;
  bubbleType?: string;
  href?: string;
  text?: React.ReactNode;
}

function BubbleText({ tooltip, style = {}, bubbleType, href, text }: BubbleTextProps) {
  const columnStyle: React.CSSProperties = {
    display: 'inline-block',
  };
  const bubbleColumnStyle: React.CSSProperties = {
    ...columnStyle,
    width: 18,
    height: 20,
    verticalAlign: 'middle',
  };
  return (
    <div title={tooltip} style={style}>
      <div style={bubbleColumnStyle}>
        <HealthBubble type={bubbleType} />
      </div>
      {href ? (
        <div style={columnStyle}>
          <a target="_blank" rel="noreferrer" href={href}>
            {text}
          </a>
        </div>
      ) : (
        <div style={columnStyle}>{text}</div>
      )}
    </div>
  );
}

export default BubbleText;
